/**
 * VATPAN Catalogs — search, filter, sort.
 */
(function () {
  'use strict';

  function parseSizeMb(value) {
    var match = String(value || '').match(/([\d.]+)/);
    return match ? parseFloat(match[1], 10) : 0;
  }

  function init(root) {
    var page = root.querySelector('[data-vatpan-catalogs]');
    if (!page) return;

    var countSingular = page.getAttribute('data-count-singular') || 'document';
    var countPlural = page.getAttribute('data-count-plural') || 'documents';
    var searchInput = page.querySelector('[data-vatpan-catalog-search]');
    var categorySelect = page.querySelector('[data-vatpan-catalog-category]');
    var sortSelect = page.querySelector('[data-vatpan-catalog-sort]');
    var grid = page.querySelector('[data-vatpan-catalog-grid]');
    var countEl = page.querySelector('[data-vatpan-catalog-count]');
    var showingEl = page.querySelector('[data-vatpan-catalog-showing]');
    var emptyState = page.querySelector('[data-vatpan-catalog-empty]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('[data-vatpan-catalog-card]')
    );

    function applyFilters() {
      var query = String(searchInput && searchInput.value ? searchInput.value : '')
        .trim()
        .toLowerCase();
      var category = categorySelect ? categorySelect.value : 'all';
      var hasCategoryFilter = !!categorySelect;
      var sort = sortSelect ? sortSelect.value : 'latest';
      var visible = [];

      cards.forEach(function (card) {
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var desc = (card.getAttribute('data-description') || '').toLowerCase();
        var cardCategory = card.getAttribute('data-category') || '';
        var matchesQuery = !query || title.indexOf(query) !== -1 || desc.indexOf(query) !== -1;
        var matchesCategory =
          !hasCategoryFilter || category === 'all' || cardCategory === category;
        var show = matchesQuery && matchesCategory;
        card.hidden = !show;
        if (show) visible.push(card);
      });

      visible.sort(function (a, b) {
        if (sort === 'az') {
          return (a.getAttribute('data-title') || '').localeCompare(
            b.getAttribute('data-title') || ''
          );
        }
        if (sort === 'size') {
          return (
            parseSizeMb(b.getAttribute('data-size')) -
            parseSizeMb(a.getAttribute('data-size'))
          );
        }
        return (
          Number(b.getAttribute('data-sort') || 0) -
          Number(a.getAttribute('data-sort') || 0)
        );
      });

      visible.forEach(function (card) {
        grid.appendChild(card);
      });

      if (countEl) {
        countEl.textContent =
          visible.length +
          ' ' +
          (visible.length === 1 ? countSingular : countPlural);
      }
      if (showingEl) {
        if (!visible.length) {
          showingEl.textContent = 'Showing 0 of ' + cards.length;
        } else {
          showingEl.textContent =
            'Showing 1–' + visible.length + ' of ' + cards.length;
        }
      }
      if (emptyState) {
        emptyState.hidden = visible.length > 0;
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
      searchInput.addEventListener('search', applyFilters);
    }
    if (categorySelect) categorySelect.addEventListener('change', applyFilters);
    if (sortSelect) sortSelect.addEventListener('change', applyFilters);

    applyFilters();
  }

  function boot(scope) {
    init(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
